import DaySeparator from './DaySeparator'

export default DaySeparator
